import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import URLS from "redux/urls";
import request from "redux/utils/request";

export const fetchAllProgram = createAsyncThunk(
  "Program/fetchAllProgram",
  async (params, { rejectWithValue }) => {
    try {
      const response = await request("get", URLS.PROGRAM, params);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addProgram = createAsyncThunk(
  "Program/addProgram",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await request("post", URLS.PROGRAM, payload);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateProgram = createAsyncThunk(
  "Program/updateProgram",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await request(
        "patch",
        `${URLS.PROGRAM}/${payload.id}`,
        payload
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const fetchOneProgram = createAsyncThunk(
  "Program/fetchOneProgram",
  async (id, { rejectWithValue }) => {
    try {
      const response = await request("get", `${URLS.PROGRAM}/${id}`);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteProgram = createAsyncThunk(
  "Program/deleteProgram",
  async (id, { rejectWithValue }) => {
    try {
      const response = await request("delete", `${URLS.PROGRAM}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const initialState = {
  loading: {
    query: false,
    mutation: false,
  },
  filter: {
    q: "",
  },
  list: [],
  count: {},
  selected: {},
  selectedRows: [],
};

const loadingReducer = (fieldName, status) => (state) => {
  state.loading[fieldName] = status;
};

const startLoadingQuery = loadingReducer("query", true);
const stopLoadingQuery = loadingReducer("query", false);
const startLoadingMutation = loadingReducer("mutation", true);
const stopLoadingMutation = loadingReducer("mutation", false);

export const ProgramSlice = createSlice({
  name: "Program",
  initialState,
  reducers: {
    setAppliedSearchText: (state, action) => {
      state.filter.q = action.payload;
    },
    setSelectedRows: (state, action) => {
      state.selectedRows = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllProgram.pending, startLoadingQuery)
      .addCase(fetchAllProgram.fulfilled, (state, action) => {
        state.list = action.payload;
        state.loading.query = false;
      })
      .addCase(fetchAllProgram.rejected, stopLoadingQuery);
    builder
      .addCase(fetchOneProgram.pending, startLoadingQuery)
      .addCase(fetchOneProgram.rejected, stopLoadingQuery)
      .addCase(fetchOneProgram.fulfilled, (state, action) => {
        state.loading.query = false;
        state.selected = action.payload;
      });
    builder
      .addCase(updateProgram.pending, startLoadingQuery)
      .addCase(updateProgram.rejected, stopLoadingQuery)
      .addCase(updateProgram.fulfilled, (state, action) => {
        state.loading.query = false;
        state.selected = action.payload;
      });
    builder
      .addCase(deleteProgram.pending, startLoadingMutation)
      .addCase(deleteProgram.fulfilled, stopLoadingMutation)
      .addCase(deleteProgram.rejected, stopLoadingMutation);
  },
});

export const { setSelectedRows, setAppliedSearchText } = ProgramSlice.actions;

export default ProgramSlice.reducer;
